import { useReducer, Reducer } from "react";

export type LoadAction<T> =
  | { type: "load_start" }
  | { type: "load_success"; data: T | undefined }
  | { type: "load_error"; errorMessageId: string | undefined };

export type LoadState<T> = { loading: boolean; loadError?: string; data?: T };

const loadingReducer = <T>(_: LoadState<T>, action: LoadAction<T>): LoadState<T> => {
  switch (action.type) {
    case "load_start":
      return { loading: true };
    case "load_success":
      return { loading: false, data: action.data };
    case "load_error":
      return { loading: false, loadError: action.errorMessageId };
    default:
      throw new Error("Invalid action");
  }
};

export function useLoaderState<T>(
  initializerArg: LoadState<T> = {
    loading: true,
  }
) {
  return useReducer<Reducer<LoadState<T>, LoadAction<T>>>(loadingReducer, initializerArg);
}
